import { Component, OnInit, AfterViewInit } from "@angular/core";
import { Subscription } from "rxjs/Subscription";
import { Location, PopStateEvent } from "@angular/common";
import "rxjs/add/operator/filter";
import { Router, NavigationEnd, NavigationStart } from "@angular/router";
import PerfectScrollbar from "perfect-scrollbar";

@Component({
  selector: "app-admin-layout",
  templateUrl: "./admin-layout.component.html",
  styleUrls: ["./admin-layout.component.css"],
})
export class AdminLayoutComponent implements OnInit, AfterViewInit {
  public router: Subscription;
  public lastPoppedUrl: string;
  public yScrollStack: number[] = [];

  /**
   * @constructor
   * @param {Location} _location 
   * @param {Router} _router 
   */
  constructor(
    public _location: Location,
    public _router: Router
  ) { }

  /**
   * OnInit
   * @returns {void}
   */
  ngOnInit(): void {
    const isWindows = navigator.platform.indexOf("Win") > -1 ? true : false;
    // ? Si es Windows, se activa la función perfectScrollbar
    if (isWindows) {
      document.getElementsByTagName("html")[0].classList.add("perfect-scrollbar-on");
    } else document.getElementsByTagName("html")[0].classList.remove("perfect-scrollbar-off");
    const elemMainPanel = <HTMLElement>document.querySelector(".main-panel");
    const elemSidebar = <HTMLElement>(document.querySelector(".sidebar .sidebar-wrapper"));
    this._location.subscribe((ev: PopStateEvent) => {
      this.lastPoppedUrl = ev.url;
    });
    this._router.events.subscribe((event: any) => {
      if (event instanceof NavigationStart) {
        if (event.url != this.lastPoppedUrl)
          this.yScrollStack.push(window.scrollY);
      } else if (event instanceof NavigationEnd) {
        if (event.url == this.lastPoppedUrl) {
          this.lastPoppedUrl = undefined;
          window.scrollTo(0, this.yScrollStack.pop());
        } else window.scrollTo(0, 0);
      }
    });
    this.router = this._router.events.filter((event) => event instanceof NavigationEnd)
      .subscribe((event: NavigationEnd) => {
        elemMainPanel.scrollTop = 0;
        elemSidebar.scrollTop = 0;
      });
    if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
      let ps = new PerfectScrollbar(elemMainPanel);
      ps = new PerfectScrollbar(elemSidebar);
    }
  }

  /**
   * runOnRouteChange
   * @returns {void}
   */
  public runOnRouteChange(): void {
    if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
      const elemMainPanel = <HTMLElement>document.querySelector(".main-panel");
      const ps = new PerfectScrollbar(elemMainPanel);
      ps.update();
    }
  }

  /**
   * Funcion que define si la plantilla corre en MAC ó IPAD
   * @returns {boolean}
   */
  public isMac(): boolean {
    return (
      navigator.platform.toUpperCase().indexOf("MAC") >= 0 || 
      navigator.platform.toUpperCase().indexOf("IPAD") >= 0 ? true : false);
  }

  /**
   * AfterViewInit
   * @returns {void}
   */
  ngAfterViewInit(): void {
    this.runOnRouteChange();
  }
}
